import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const NewsletterPage = () => (
  <Container sx={{ py: 10, minHeight: 400 }}>
    <Typography variant="h3" align="center" gutterBottom>
      Newsletter
    </Typography>
    <Typography align="center" sx={{ mb: 4 }}>
      Subscribe to our newsletter to get the latest updates. (Feature coming soon!)
    </Typography>
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      {/* Placeholder for future subscription form */}
    </Box>
  </Container>
);

export default NewsletterPage; 